	export enum TimeSlotTypeEnum {
		Appointment = 1,
		UnavailableSlot = 2,
		AppointmentSlot = 3
	}
